import { useState } from "react";
import { Organization } from "@/pages/AdminConsole";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@/components/ui/table";
import { useTranslation } from "react-i18next";

interface OrganizationTableProps {
  organization: Organization[];
  isLoading: boolean;
  onEditCompany: (company: Organization) => void;
}

export const OrganizationTable = ({
  organization: organizations,
  isLoading,
  onEditCompany
}: OrganizationTableProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <div className="text-center py-4">{t("admin.loading")}</div>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t("common.name")}</TableHead>
          <TableHead className="text-right">{t("common.actions")}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {organizations.length === 0 ? (
          <TableRow>
            <TableCell colSpan={2} className="text-center py-4">
              {t("common.noData")}
            </TableCell>
          </TableRow>
        ) : (
          organizations.map((company) => (
            <TableRow key={company.id}>
              <TableCell>{company.name}</TableCell>
              <TableCell className="text-right">
                <Button 
                  variant="ghost" 
                  size="icon"
                  onClick={() => onEditCompany(company)}
                >
                  <Edit className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
